import "./App.css";
import Navbar from "./components/Navbar/Navbar"
import ParticleBackground from "./ParticleBackground";

function App() {
  return (
    <div>
      <Navbar />
      <ParticleBackground />
      <CenterTitle />
      
    </div>
  );
}
function CenterTitle() {
  return(
    <div id="center_text">
      
      <div className="center_all">
      <img className="photo" src="http://deepty.camaraguajira.org/img/deepty.gif" style={{Align: "center"
            }} />
        <h1 className="custom-subTitle"> Chatbot </h1>
        
      </div>

    </div>
  )
}



export default App;
